import * as React from 'react';
import { observer } from 'mobx-react';
import { AutoComplete } from 'components/Common/autoComplete';
import { AssignUserModalView as AssignUserModalViewStore } from 'nomst/Stores/Configuration/assignUserModalView';
import { defaultSearchResultLimit, emptyFunction } from 'common/constants';

export interface IAssignUserModalViewProps {
    store: AssignUserModalViewStore;
    searchAllUserTypes: boolean;
}

const getSelectedValue = (user: ISuggestedUser) => user.displayName;

@observer
export default class AssignUserModalView extends React.Component<IAssignUserModalViewProps> {
    constructor(props: IAssignUserModalViewProps) {
        super(props);

        this.save = this.save.bind(this);
        this.searchUsers = this.searchUsers.bind(this);
        this.setFoundUser = this.setFoundUser.bind(this);
        this.clearFoundUser = this.clearFoundUser.bind(this);
        this.getSearchSuggestionText = this.getSearchSuggestionText.bind(this);
        this.hideModal = this.hideModal.bind(this);
    }

    render(): React.ReactNode {
        const { store } = this.props;
        if (!store.isModalShown) {
            return null;
        }

        return (
            <div className="pxl-modal confirmation-modal">
                <div className="pxl-modal__content">
                    <h1 className="pxl-header-xsmall">Assign User to Selected Groups</h1>
                    <div>
                        <AutoComplete
                            id="searchUser"
                            placeholder={'Search user...'}
                            search={this.searchUsers}
                            resultLimit={defaultSearchResultLimit}
                            onChangeInput={emptyFunction}
                            onSuggestionSelected={this.setFoundUser}
                            onClearSearch={this.clearFoundUser}
                            getSelectedValue={getSelectedValue}
                            getRenderedSuggestionText={store.getSearchSuggestionText}
                            initialValue={''}
                            disableInput={false}
                        />
                    </div>
                    <div className="pxl-text-right">

                        <button className="pxl-link" onClick={this.hideModal}>Cancel</button>
                        <button
                            disabled={!store.selectedUserFromSuggestion}
                            onClick={this.save}
                            className="pxl-btn pxl-btn--primary pxl-margin-left-large"
                        >
                                Save
                        </button>

                    </div>
                </div>
            </div>
        );
    }

    private hideModal(): void {
        this.props.store.hideModal();
    }

    private getSearchSuggestionText(_: undefined, user: ISuggestedUser): void {
        this.props.store.getSearchSuggestionText(user);
    }

    private clearFoundUser(): void {
        this.props.store.clearFoundUser();
    }

    private setFoundUser(user: ISuggestedUser): void {
        this.props.store.setFoundUser(user);
    }

    private save(): void {
        this.props.store.save();
    }

    private async searchUsers(searchText: string, resultLimit: number): Promise<ISuggestedUser[]> {
        const { store, searchAllUserTypes } = this.props;
        const result = await store.searchUsers(searchText, resultLimit, searchAllUserTypes);
        return result ?? [];
    }
}